import { format, parse, sub, isValid, isAfter, parseISO } from 'date-fns';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import th from 'dayjs/locale/th';

dayjs.extend(utc);
dayjs.extend(timezone);

export const formatDateTime = (date) => format(date, 'yyyy-MM-dd HH:mm:ss');

export const getCurrentMonthYear = () => format(new Date(), 'MMM yyyy');

export const parseDateTime = (date) =>
    parse(date, 'yyyy-MM-dd HH:mm:ss', new Date());

export const parseDateTimeISO = (dateStr) => {
    const date = parseISO(dateStr.split('.')[0]);
    return format(date, 'dd MMM yyyy h:mm a');
};

export const formatPortfolioIssueDate = (date) => format(date, 'yyyy-MM-dd');

export const formatBirthDate = (date) => format(date, 'yyyy-MM-dd');

export const formatBirthDateStr = (dateStr) =>
    format(parse(dateStr, 'yyyy-MM-dd HH:mm:ss', new Date()), 'yyyy-MM-dd');

export const getRegistrationMaxDate = () => sub(new Date(), { months: 216 });

export const parseICDob = (ic) => {
    const dob = ic.slice(0, 6);
    const dobDate = parse(dob, 'yyMMdd', new Date());
    if (isValid(dobDate)) {
        return dobDate;
    }
    return '';
};

export const checkIsDobOverLimit = (date) =>
    isAfter(date, getRegistrationMaxDate());

export const currDateStringGetter = () => {
    const currentDate = new Date();
    const curDay = currentDate.getDate();
    const curMonth = currentDate.getMonth() + 1;
    const curYear = currentDate.getFullYear();
    const curHours = currentDate.getHours();
    const curMinutes = currentDate.getMinutes();

    return {
        curDay,
        curMonth,
        curYear,
        curHours,
        curMinutes,
    };
};

export const dateFormatter = (dateString, language) => {
    let bangkokDate = dayjs.utc(dateString).tz('Asia/Bangkok');

    if (language === 'th') {
        bangkokDate = bangkokDate.locale('th');
    } else {
        bangkokDate = bangkokDate.locale('en');
    }

    return bangkokDate.format('D MMM, YYYY');
};

export const yearMonthFormatter = (dateString, language) => {
    const [year, month] = dateString.split('-');
    const formattedDate = new Date(Date.UTC(year, month - 1));

    let monthString;
    if (language === 'th') {
        monthString = formattedDate.toLocaleString('th-TH', { month: 'short' });
    } else {
        monthString = formattedDate.toLocaleString('en-US', { month: 'short' });
    }

    return `${monthString} ${year}`;
};